import $ from 'jquery';

(function () {
  const $body = $('body');

  const closeMegaMenu = function() {
    $('.navigation-main__anchor--active').removeClass('navigation-main__anchor--active');
    $('.js-mega-menu-cover').remove();
  };

  $('.navigation-main__anchor').on('click', function(event) {
    const $anchor = $(this);
    const $megaMenu = $anchor.next('.navigation-main__mega-menu');
    if ($megaMenu.length === 0) {
      return;
    }

    if ($anchor.hasClass('navigation-main__anchor--active')) {
      closeMegaMenu();
      return;
    }

    event.preventDefault();

    if ($megaMenu.find('.mega-menu__close-button').length === 0) {
      const $closeIcon = $('<a href="#" class="mega-menu__close-button button button--size-regular button--style-regular button--color-green button--icon-only">' +
        '  <svg class="icon"><use xlink:href="#cross"/></svg>' +
        '</a>');
      $closeIcon.prependTo($megaMenu);
    }

    closeMegaMenu();
    $anchor.addClass('navigation-main__anchor--active');
    $('body').append('<div class="mega-menu-cover js-mega-menu-cover"></div>');

  });

  $body.on('click', '.mega-menu__close-button', function(event) {
    event.preventDefault();
    closeMegaMenu();
  });

  $body.on('click', '.mega-menu', function(event) {
    if ($(event.target).hasClass('navigation-main__mega-menu')) {
      closeMegaMenu();
    }
  });
})();
